// Abas do card de cada fornecedor no Efetivo (Rafael 25/10): Faturamento, Parcelas de Pagamento,
// Documento Fiscal e Adiantamento. Cada aba leva um selo curto com a situação, para não precisar abrir.

export const ABAS_EFETIVO = ['faturamento', 'parcelas', 'documento', 'adiantamento'];

// Pagamento pelo cliente não tem parcela, nota nem adiantamento: só a aba Faturamento vale.
export const abaEfetivoValida = (aba, ef) => {
    if ((ef || {}).quem_paga === 'cliente') return 'faturamento';
    return ABAS_EFETIVO.includes(aba) ? aba : 'faturamento';
};

/**
 * Selo de cada aba: { texto, tom } ou null (sem selo). tom = '' | 'is-ok' | 'is-warn'.
 * @param {object} forn fornecedor do payload do Efetivo (nf_por_parcela, nf_parcelas, nfs, usar_adiantamento)
 * @param {object} ef   estado editável do Efetivo do fornecedor (quem_paga, tipo_faturamento, parcelas, usar_adiantamento)
 */
export const statusAbasEfetivo = (forn, ef) => {
    const f = forn || {};
    const e = ef || {};
    if (e.quem_paga === 'cliente') {
        return { faturamento: { texto: 'Cliente', tom: 'is-warn' }, parcelas: null, documento: null, adiantamento: null };
    }

    const tipo = String(e.tipo_faturamento || '').toLowerCase();
    const faturamento = tipo === 'nf' || tipo === 'nd' ? { texto: tipo.toUpperCase(), tom: '' } : null;

    const nParcelas = (e.parcelas || []).length;
    const parcelas = nParcelas ? { texto: String(nParcelas), tom: '' } : null;

    let documento;
    const porParcela = f.nf_por_parcela ? (f.nf_parcelas || []) : [];
    if (porParcela.length) {
        const comNf = porParcela.filter((p) => !p.pendente).length;
        documento = { texto: `${comNf}/${porParcela.length}`, tom: comNf === porParcela.length ? 'is-ok' : 'is-warn' };
    } else {
        const recebidas = (f.nfs || []).filter((n) => n.arquivo_id).length || (f.nf_arquivo_id ? 1 : 0);
        documento = recebidas ? { texto: recebidas > 1 ? `${recebidas} NFs` : 'NF', tom: 'is-ok' } : { texto: 'Pendente', tom: 'is-warn' };
    }

    const usa = f.usar_adiantamento === 'sim' || e.usar_adiantamento === 'sim';
    const adiantamento = usa ? { texto: 'Sim', tom: 'is-ok' } : null;

    return { faturamento, parcelas, documento, adiantamento };
};
